import { render, staticRenderFns } from "./balances.vue?vue&type=template&id=0ecf3622&"
import script from "./balances.vue?vue&type=script&lang=js&"
export * from "./balances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports